export type ExcelRichTextSegment = { text: string };

export type ExcelCellLike = {
  text?: string;
  richText?: ExcelRichTextSegment[];
  result?: unknown;
};

/**
 * Normaliza el valor de una celda a string, evitando devolver "[object Object]".
 */
export function normalizeCell(cell: unknown): string {
  if (cell == null) return '';

  if (typeof cell === 'object') {
    const anyCell = cell as ExcelCellLike;

    if (typeof anyCell.text === 'string') {
      return anyCell.text;
    }

    if (Array.isArray(anyCell.richText)) {
      return anyCell.richText.map((r) => r.text).join('');
    }

    if (anyCell.result != null) {
      return typeof anyCell.result === 'object'
        ? safeStringify(anyCell.result)
        : String(anyCell.result);
    }

    return safeStringify(cell);
  }

  return String(cell);
}

/**
 * Convierte un valor a JSON string de forma segura.
 * Si no se puede, devuelve "" en lugar de "[object Object]".
 */
function safeStringify(value: unknown): string {
  try {
    return JSON.stringify(value) ?? '';
  } catch {
    return '';
  }
}

export default normalizeCell;
